// This class creates the index of currency pairs for StrengthCalculator class

export class StrengthMeterCurrencyIndex {
  constructor(currency, listCurrencies, typeIndex, listSymbols) {
    this.indexName = currency;
    this.stringRating = {};

    this.updateRating = this.updateRating.bind(this);
    this.createListPairs = this.createListPairs.bind(this);

    this.listPairs = this.createListPairs(
      listCurrencies,
      typeIndex,
      listSymbols
    );
  }

  updateRating(timeframes) {
    const rating = {};
    for (const i in timeframes) {
      rating[timeframes[i]] = 0;
    }
    this.listPairs.forEach((pair) => {
      for (const tf in pair.startRate) {
        if (pair.rate > pair.startRate[tf]) {
          rating[tf]++;
        }
      }
    });
    this.indexRating = rating;
  }

  createListPairs(listCurrencies, typeIndex, listSymbols) {
    const result = [];
    if (!typeIndex) {
      listCurrencies.forEach((curr) => {
        const pair = {};
        pair.base = this.indexName;
        pair.quote = curr;
        pair.startRate = 0;
        pair.rate = 0;
        pair.name = this.indexName + curr;
        if (this.indexName != curr) {
          result.push(pair);
        }
      });
    } else {
      const pair = {};
      pair.base = listSymbols[this.indexName].base;
      pair.quote = listSymbols[this.indexName].quote;
      pair.startRate = 0;
      pair.rate = 0;
      pair.name = this.indexName;
      result.push(pair);
    }
    return result;
  }
}
